import React from 'react';
import ThColorPicker from '../../forms/th-color-picker';
import InputTextArea from '../../forms/th-iput-text-area';
import Button from '../../UI/button';
import ModalCustom from '../../UI/modal';
import { Form } from 'react-bootstrap';
import ThDropdown from '../../forms/th-dropdown';
import cn from 'classnames';
import ThInputsDate from '../../forms/th-inputs-date';
import { useEditDay } from './use-edit-day';
import { useTrip } from '../../contexts/trip-context';
import { useTripModal } from '../../contexts/modal-context-trip';

type Props = {
  show: boolean;
  handleClose: () => void;
};

const EditDayModal = ({ show, handleClose }: Props) => {
  const [day, setDay] = React.useState<boolean>(false);
  const [color, setColor] = React.useState<string>('#842234');
  const [description, setDescription] = React.useState<string>('');

  const { trip } = useTrip();
  const { getDayData } = useTripModal();
  const dayData = getDayData();

  const tripId = trip?.id || '';
  const itineraryId = trip?.itineraries?.[0]?.id || '';
  const dayId = dayData?.id || '';

  const {
    day: editDay,
    isSubmitting,
    error,
    isLoading,
    handleSubmitWithData
  } = useEditDay(dayId, tripId, itineraryId, () => {
    handleClose();
  });

  // Update local state when day data is loaded
  React.useEffect(() => {
    if (editDay) {
      setColor(editDay.color);
      setDescription(editDay.description || '');
    }
  }, [editDay]);

  const onSubmit = () => {
    const dayUpdateData = {
      color,
      title: editDay?.title || 'Day',
      description
    };

    handleSubmitWithData(dayUpdateData);
  };

  if (isLoading) {
    return (
      <ModalCustom
        title='Edit Day Details'
        show={show}
        onHide={handleClose}
      >
        <div className='text-center p-4'>
          <div>Loading...</div>
        </div>
      </ModalCustom>
    );
  }

  return (
    <ModalCustom
      title='Edit Trip Details'
      show={show}
      onHide={handleClose}
    >
      <Form>
        <Form.Group>
          <Form.Label>
            <div className='add-day-label'>
              Select<span className='text-primary'>*</span> :{' '}
              <div className='choose-day-date'>
                <span
                  className={cn({ active: !day })}
                  onClick={() => setDay(!day)}
                >
                  Day
                </span>
                <span
                  className={cn({ active: day })}
                  onClick={() => setDay(!day)}
                >
                  Date
                </span>
              </div>
            </div>
          </Form.Label>
          {!day ? (
            <ThDropdown
              id='select-day-number'
              label='Select Day Number'
              labelShow={false}
              optionsArrays={[
                [
                  { id: '1', name: 'Day 1' },
                  { id: '2', name: 'Day 2' },
                  { id: '3', name: 'Day 3' },
                  { id: '4', name: 'Day 4' }
                ]
              ]}
              required={true}
            />
          ) : (
            <ThInputsDate />
          )}
        </Form.Group>
        <ThColorPicker
          initialColor={color}
          onChange={(color) => setColor(color)}
        />
        <ThDropdown
          id='add-activity-numbering'
          label='Add Activity Numbering'
          optionsArrays={[
            [
              { id: 'yes', name: 'Yes' },
              { id: 'no', name: 'No' }
            ]
          ]}
          required={false}
        />
        <InputTextArea
          label='Description'
          placeholder='Enter here'
          value={description}
          onChange={setDescription}
          required={false}
          rowCount={3}
        />
        <Button
          variant='primary'
          px={50}
          className='mx-auto'
          onClick={onSubmit}
          disabled={isSubmitting}
        >
          {isSubmitting ? 'Updating...' : 'Edit Day'}
        </Button>
        {error && <div className='text-danger mt-2 text-center'>{error}</div>}
      </Form>
    </ModalCustom>
  );
};
export default EditDayModal;
